<template>
  <div class="location-search">
    <label class="mb-1 font-weight-bold">{{ label }}</label>

    <input
        type="text"
        class="form-control"
        v-model="keyword"
        @input="onInput"
        @focus="showDropdown = true"
        :placeholder="placeholder"
    />

    <div v-if="showDropdown" class="dropdown-list">
      <div v-if="loading" class="dropdown-item">Loading...</div>

      <div
          v-for="item in options"
          :key="item.value"
          class="dropdown-item"
          @click="selectItem(item)"
      >
        {{ item.label }}
      </div>

      <div
          v-if="hasSearched && !loading && options.length === 0 && keyword.length >= 3"
          class="dropdown-item"
      >
        Tidak ditemukan
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocationSearch",
  props: {
    value: null,
    options: {
      type: Array,
      default: () => []
    },
    loading: Boolean,
    label: String,
    placeholder: String
  },
  data() {
    return {
      keyword: "",
      showDropdown: false,
      debounceTimer: null,
      hasSearched: false,
      isSelected: false,
      selectedLabel: ""
    };
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    if (this.value) {
      this.keyword = this.value;
      this.selectedLabel = this.value;
      this.isSelected = true;
    }
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.keyword = newVal;
        this.selectedLabel = newVal;
        this.isSelected = true;
      } else {
        this.keyword = "";
        this.selectedLabel = "";
        this.isSelected = false;
      }
    }
  },

  methods: {
    onInput() {
      clearTimeout(this.debounceTimer);

      this.hasSearched = false;
      this.isSelected = false;
      this.selectedLabel = "";

      this.debounceTimer = setTimeout(() => {
        this.$emit("search", this.keyword);
        this.hasSearched = true;
      }, 400);
    },

    selectItem(item) {
      this.keyword = item.label;
      this.selectedLabel = item.label;
      this.showDropdown = false;
      this.isSelected = true;

      this.$emit("input", item.value);
      this.$emit("selected", item);
    },

    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.showDropdown = false;

        if (!this.isSelected || this.keyword !== this.selectedLabel) {
          this.keyword = "";
          this.selectedLabel = "";
          this.$emit("input", null);
        }
      }
    }
  }
};
</script>

<style scoped>
.location-search {
  position: relative;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #ddd;
  z-index: 9999;
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-item {
  padding: 8px;
  cursor: pointer;
}

.dropdown-item:hover {
  background: #f2f2f2;
}
</style>